export default "__VITE_ASSET__BpnmUhUH__"